import React from 'react'
import {connect} from "react-redux";
import BmPort from "./BmPort";

const Bm = ({node, header, size}) => {
    const _size = size || 32
    const _node = node || {}

    let zz = []
    if( _node && _node.bm_states) {
        for (let x of Object.keys(_node.bm_states)) {
            let yy = _node.bm_states[x]
            zz.push(<BmPort key={_node.uid + "_" + yy.bm_port} uid={_node.uid} port={yy} size={_size}/>)
        }
    }

    const _uid = _node && _node.uid && `V${_node.uid.slice(4, 6)}P${_node.uid.slice(6)}`
    const _user = _node && _node.user && _node.user.replaceAll('http://', '').replace(/:[0-9]+/, '')
    const _prod = _node && _node.product
    const _title = header && `${_user || _uid} (${_prod})` // + ` | ${node && node.path} | ${node && node.uid}`

    return (
        <div style={{
            margin: 5,
        }}>
            <div style={{
                padding: '5px',
            }}>{_title}</div>
            <div style={{
                //width: (30)+'vw',
                //height: (8)+'vw',
                display: 'inline-grid',
                gridTemplateColumns: 'auto auto auto auto auto auto auto auto',
                padding: '2px',
                gridGap: '5px',
                marginLeft: '5px',
                marginBottom: '5px',
            }}>
                {zz}
            </div>
        </div>
    )
}

function mapStateToProps(state, other) {
    return {node: state.bidib.data.node.find(it => it.uid === other.nodeid)}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Bm)